import { useBusinessEntityDocuments } from '@commenda/api';
import { LoadingIndicator } from '@commenda/kakashi';
import { IBusinessEntity } from '@commenda/types';
import { documentDescription, downloadFileFromFileId } from '@commenda/utils';
import { LegacyDocumentType } from '@prisma/client';
import { DataPoint } from '../../common/DataPoint';
import { SummaryInfoWrapper } from './SummaryInfoWrapper';

type OwnershipCardProps = {
  onGoToForm: () => void;
  businessEntity: IBusinessEntity;
};

export const OwnershipCard = ({
  onGoToForm,
  businessEntity,
}: OwnershipCardProps) => {
  const { data: documentsResponse, error: documentsResponseError } =
    useBusinessEntityDocuments({
      businessEntityId: businessEntity.id,
    });

  if (!documentsResponse || documentsResponseError) {
    console.error(documentsResponseError);
    return <LoadingIndicator />;
  }

  const capTableDocuments =
    documentsResponse?.documents?.filter(
      (document) => document.documentSubType === LegacyDocumentType.CapTable
    ) ?? [];

  const capTableDocument =
    capTableDocuments[capTableDocuments.length - 1] ?? null;

  return (
    <SummaryInfoWrapper title="Ownership" onGoToForm={onGoToForm}>
      <div className="rounded-xl overflow-clip divide-y divide-border-primary">
        <DataPoint
          description={documentDescription(capTableDocument?.documentSubType)}
          key={`${capTableDocument?.id}-${capTableDocument?.documentSubType}`}
          title="Cap Table"
          value={
            !capTableDocument?.fileName ? 'N/A' : capTableDocument?.fileName
          }
          document={
            capTableDocument
              ? {
                  id: capTableDocument?.id ? +capTableDocument.id : null,
                  isSupported: true,
                  fileUrl: capTableDocument?.fileUrl || null,
                  fileName: capTableDocument?.fileName || null,
                  onViewDocument: () =>
                    downloadFileFromFileId(
                      capTableDocument?.id ? +capTableDocument.id : null,
                      capTableDocument?.fileName
                    ),
                }
              : undefined
          }
        />
      </div>
    </SummaryInfoWrapper>
  );
};
